// Google Map Component
import React, { useEffect, useState } from "react";
import {
  GoogleMap,
  Marker,
  withScriptjs,
  withGoogleMap,
} from "react-google-maps";
import { compose, withProps, withHandlers } from "recompose";
// import { useNavigate } from "react-router-dom";
// Config
import config from "../../service/config";
//Style
import "./style.scss";
//Images
import Dining from "../../assets/img/map/dining.png";
import SelectedDining from "../../assets/img/map/dining_select.png";
import Apparel from "../../assets/img/map/apparel.png";
import ApparelSelect from "../../assets/img/map/apparel_select.png";
import Retail from "../../assets/img/map/retail.png";
import ReatilSelect from "../../assets/img/map/retail_select.png";
import Miscellance from "../../assets/img/map/miscellance.png";
import MiscellanceSelect from "../../assets/img/map/miscellance_select.png";
import Travel from "../../assets/img/map/travel.png";
import TravelSelect from "../../assets/img/map/travel_select.png";
import Personal from "../../assets/img/map/personal.png";
import PersonalSelect from "../../assets/img/map/personal_select.png";
import Entertainment from "../../assets/img/map/entertainment.png";
import EntertainmentSelect from "../../assets/img/map/entertainment_select.png";
// Component
// import InfoCard from "../MapListCard";
// import MapDesktopCard from "../MapDesktopCard";
// Helper
// import { truncateStr } from "../MapListCard/helper";
const {
  MarkerWithLabel,
} = require("react-google-maps/lib/components/addons/MarkerWithLabel");
const CategorySelectedIcon = (category) => {
    if (category === "apparel and accessories") {
      return ApparelSelect;
    } else if (category === "retail stores") {
      return ReatilSelect;
    } else if (category === "miscellaneous stores") {
      return MiscellanceSelect;
    } else if (category === "travel") {
      return TravelSelect;
    } else if (category === "personal service providers") {
      return PersonalSelect;
    } else if (category === "entertainment") {
      return EntertainmentSelect;
    }
    return SelectedDining;
  };
  
  const CategoryNormalIcon = (category) => {
    // console.log(category)
    if (category === "apparel and accessories") {
      return Apparel;
    } else if (category === "retail stores") {
      return Retail;
    } else if (category === "miscellaneous stores") {
      return Miscellance;
    } else if (category === "travel") {
      return Travel;
    } else if (category === "personal service providers") {
      return Personal;
    } else if (category === "entertainment") {
      return Entertainment;
    }
    return Dining;
  };
const GoogleMapComponent = compose(
  // withProps({}),
  withScriptjs,
  withGoogleMap,
  withHandlers(() => {
    const refs = {
      map: undefined,
    };
    return {
      onMapMounted: () => (ref) => {
        refs.map = ref;
      },
      onZoomChanged:
        ({ zoomChanged, onMapBoundsChange }) =>
        () => {
          zoomChanged(refs.map.getBounds(), refs.map.getCenter());
        },
      onDrag:
        ({ zoomChanged, onMapBoundsChange }) =>
        () => {
          zoomChanged(refs.map.getBounds(), refs.map.getCenter());
        },
      onClick:
        ({ handleClickInsideMap }) =>
        () => {
          handleClickInsideMap();
        },
    };
  })
)((props) => (
    <GoogleMap
    defaultZoom={10}
    center={props.focus}
    ref={props.onMapMounted}
    onZoomChanged={props.onZoomChanged}
    clickableIcons={false}
    // onDrag={props.onDrag}
    onClick={props.onClick}
    onDragEnd={props.onDrag}
    options={{
      scrollwheel: props.width > 800 ? true : false,
      fullscreenControl: false,
      streetViewControl: false,
      mapTypeControl: false,
      draggable: true,
      zoomControlOptions: {
        position: window.google.maps.ControlPosition.RIGHT_TOP,
      },
      styles: [
        {
          featureType: "administrative",
          elementType: "all",
          stylers: [
            {
              visibility: "simplified",
            },
          ],
        },
        {
          featureType: "landscape",
          elementType: "all",
          stylers: [
            {
              visibility: "on",
            },
          ],
        },
        {
          featureType: "poi",
          elementType: "all",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        {
          featureType: "transit",
          elementType: "all",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
      ],
    }}
  >
    
    
    {props.locationData && props.locationData.locations!==undefined && props.locationData.locations.map((item,idx) => {
        return (
            <>
              {item?.geoCode?.latitude && item?.geoCode?.longitude && (
                <>
                <MarkerWithLabel
                key={idx}
                onClick={() => props.handleClickMarker(item)
                  }
                position={{
                    lat: parseFloat(item?.geoCode?.latitude),
                    lng: parseFloat(item?.geoCode?.longitude),
                  }}
                labelAnchor={{
                    x:
                      -5,
                    y:
                      35
                }}
                // labelAnchor={new google.maps.Point(0, 0)}
                // labelClass={
                //   "map-label"
                    
                // }
                // labelStyle={{
                //     backgroundColor:
                //       item.id === props.markerID && props.width > 800
                //         ? "#ffffff"
                //         : item.id === props.markerID && props.width < 800
                //         ? "#000000"
                //         : "#6F848F",
                //   }}
                icon={{
                    url:CategorySelectedIcon(props.merchantItem?.category),
                    anchor: new window.google.maps.Point(17, 46),
                    scaledSize: new window.google.maps.Size(20, 28),
                  }}
                >
                <div style={{fontSize:"12px"}}>{props.merchantItem?.name}</div>
                </MarkerWithLabel>
                </>
                )}
            </>)
    })}
    
  </GoogleMap>
));
const MapComponent = (props) => {
  
    const [center, setCenter] = useState({});
    const [markN, setMarkN] = useState({});
    const [marks, setMarkS] = useState({});
    const [markerID, setMarkerID] = useState({});
    const [locationData, setLocationData] = useState([]);
    const [width, setWidth] = useState(window.innerWidth);
    const [focus, setFocus] = useState();
  const {
    homeList,
    merchantItem
  } = props;
  const handleCenterChanged = (bounds, centerBounds) => {
    const ne = {
      lat: bounds.getNorthEast().lat(),
      lng: bounds.getNorthEast().lng(),
    }; //top right boundary of map
    const sw = {
      lat: bounds.getSouthWest().lat(),
      lng: bounds.getSouthWest().lng(),
    };
    const center = {
      lat: centerBounds.lat(),
      lng: centerBounds.lng(),
    };
    setMarkN(ne);
    setMarkS(sw);
    // setCenter(center);
    // let radiusVal = distance(ne.lat, ne.lng, sw.lat, sw.lng) / 2;
    // setRadius(Math.round(radiusVal * 1000));
    // handleChangeRadiusCenter({ radiusVal, center });
  };
  const handleClickInsideMap = () => {
    setMarkerID({});
    // setCardVisible(true);
  };
  const handleClickMarker = (item) => {
    let focusValue = {
      lat: parseFloat(item?.geoCode?.latitude),
      lng: parseFloat(item?.geoCode?.longitude),
    };
    setMarkerID(item.geoCode);
    if (width > 800) {
      setFocus(focusValue);
    }
    window.open("https://maps.google.com?q="+item?.geoCode?.latitude+","+item?.geoCode?.longitude );
  };
  useEffect(() => {
    let localValue = homeList?.locations[0]?.geoCode?.latitude && homeList?.locations[0]?.geoCode?.latitude !== "" ? homeList?.locations[0]?.geoCode : JSON.parse(localStorage.getItem("selectCountry"))?.geoCode;
    if (localValue) {
      let centerValue = {
        lat: parseFloat(localValue.latitude),
        lng: parseFloat(localValue.longitude),
      };
      setCenter(centerValue);
      setMarkN(centerValue);
      setMarkS(centerValue);
      setFocus(centerValue);
    }
    window.addEventListener("resize", updateMedia);
    return () => window.removeEventListener("resize", updateMedia);
  }, [merchantItem.geoCodes]);
  useEffect(() => {
    setLocationData(homeList);
  }, [homeList]);
  
  const updateMedia = () => {
    setWidth(window.innerWidth);
  };
  
  return (
    <GoogleMapComponent
      width={width}
      center={center}
      focus={focus}
      locationData={locationData}
      merchantItem={merchantItem}
      zoomChanged={(bounds, center) => handleCenterChanged(bounds, center)}
      markN={markN}
      marks={marks}
    //   radius={radius}
      handleClickMarker={handleClickMarker}
      markerID={markerID}
    //   handleClickMerchant={handleClickMerchant}
    //   getMapDetails={getMapDetails}
    //   cardVisble={cardVisble}
      handleClickInsideMap={handleClickInsideMap}
      googleMapURL={`https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,drawing,places&key=${config.mapKey}`}
      loadingElement={<div style={{ height: `100%` }} />}
      containerElement={
        <div style={{ height: "320px" }} />
      }
      mapElement={
        <div
          style={{ height: `300px`, borderRadius: "20px"}}
        />
      }
    />
  );
};
export default MapComponent;